import { useCustomerNumberSearch } from "@/react/features/smp/dms/useCustomerNumberSearch";
import { useEffect, useMemo } from "react";
import { useGetBranchesQuery } from "@/react/services/common/branchesApi";

const createNumberToDidIdMap = (dids) => {
  return (dids || []).reduce((didMap, { phoneNumber, uuid }) => {
    didMap[phoneNumber] = uuid;
    return didMap;
  }, {});
};

const createBranchNameToIdMap = (branches) => {
  return (branches || []).reduce((branchMap, { name, branchId }) => {
    branchMap[name] = branchId;
    return branchMap;
  }, {});
};

export const usePrimaryDidAndBranchIds = () => {
  const {
    dids,
    searchDids,
    isFetching: isFetchingDids,
  } = useCustomerNumberSearch();

  useEffect(() => {
    searchDids();
  }, [searchDids]);

  const { data: branches, isFetching: isFetchingBranches } =
    useGetBranchesQuery();

  return useMemo(
    () => ({
      isFetchingDids,
      isFetchingBranches,
      dids: createNumberToDidIdMap(dids),
      branches: createBranchNameToIdMap(branches),
    }),
    [dids, branches, isFetchingBranches, isFetchingDids]
  );
};
